<template>
    <div class="result brandheader multibrand row cf">
        <div class='logocol medium-2 large-2 columns'>
            <div class='logo'>
                <a v-if="(brandproduct.brand_url != '')" :href="brandproduct.brand_url" target="_blank"><img
                        :src="brandproduct.logo_url" :alt='brandproduct.name'/></a>
                <img v-if="(brandproduct.brand_url == '')" :src="brandproduct.logo_url" :alt='brandproduct.name'/>
            </div>
        </div>

        <div class='medium-10 large-10 columns'>
            <h5 class='brandname'>
                <a v-on:click="show_products_for_brand(brandproduct.id, cat_id, keyword)" class='seeall'>{{
                    brandproduct.name }}</a>

                <span v-if="brandproduct.total_products"
                      class='count'>{{ brandproduct.total_products }} products</span>

                <span v-if="((products_in_cat.length > 0) && (parseInt(cat_id) > 0))"
                        class='count'>{{ products_in_cat.length }} products in category</span>


                <span v-if="((products.length > 0) && (keyword.length))"
                        class='count'>{{ products.length }} products matching keyword {{ keyword }}</span>

                <span v-if="((brandproduct.total_products == '') && (products_in_cat.length > 0) && (parseInt(cat_id) == 0))"
                        class='count'>/ {{ products_in_cat.length }} total products for this brand</span>

            </h5>
            <div class="show_products_button" v-on:click="show_products_for_brand(brandproduct.id, cat_id, keyword, false)"
                 v-if="(!show_payload)">
                <span v-if="brandproduct.total_products">Show products this brand <i
                        class='fa fa-chevron-right'></i></span>

                <span v-if="(products_in_cat.length)">Show products in this category for this brand <i
                        class='fa fa-chevron-right'></i></span>
                <span v-if="(products.length)">Show products matching keyword {{ keyword }} for this brand <i
                        class='fa fa-chevron-right'></i></span>
            </div>


            <div v-if="loading" class="loading min">
                <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>


            <div class='brandpayload' style="display: block" v-if="(!loading && show_payload)">
                <ul v-if="(!loading && !show_all && products_in_cat)">
                    <li v-for="product in products_in_cat" v-bind:key="product.id">
                        {{ product.name }}
                    </li>
                </ul>
                <ul v-if="(!loading && !show_all && products)">
                    <li v-for="product in highlighted_products" v-bind:key="product.id">
                        {{ product.name }}
                    </li>
                </ul>
                <ul v-if="(!loading && show_all)">
                    <li v-for="product in products_all" v-bind:key="product.id">
                        {{ product.name }}
                    </li>
                </ul>
                <div class="show_all_products_button" v-on:click="show_products_for_brand(brandproduct.id, cat_id, keyword, true)"
                     v-if="(!loading && !show_all && products_in_cat.length && (products_in_cat.length != products_all.length))">
                    See all products for this brand
                </div>
                <div class="show_all_products_button" v-on:click="show_products_for_brand(brandproduct.id, cat_id, keyword, true)"
                     v-if="(!loading && !show_all && products.length && (products.length != products_all.length))">
                    See all products for this brand
                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import ApiService from '../services/ApiService';

    export default {
        name: 'BrandWithProducts',
        props: {
            msg: String,
            brandproduct: Object,
            totalshown: 0,
            cat_id:
                {
                    type: Number,
                    default: 0
                },
            keyword:
                {
                    type: String,
                    default: ''
                }
        },
        data() {
            return {
                loading: false,
                errored: false,
                products_all: [],
                products_in_cat: [],
                products: [],
                show_payload: false,
                show_all: false
            }
        },
        mounted() {
            if (this.keyword != '') this.products = this.brandproduct.products;
            if (this.cat_id != '') this.products_in_cat = this.brandproduct.products;
            if ((this.products.length > 0) || (this.products_in_cat.length > 0)) this.show_payload = true;
            if(this.totalshown == 1) {
                this.show_payload = true;
                this.products_all = this.brandproduct.products;
                this.products = this.brandproduct.products;
            }
        },
        methods: {
            show_products_for_brand(brand_id, cat_id, keyword, show_all) {
                this.$router.push({ query: { brand_id: brand_id } });
                this.loading = true;
                console.log('get products', brand_id, cat_id, keyword);
                this.show_all = show_all;
                ApiService.getProductsForBrand(brand_id, cat_id).then(response => {
                    this.products_all = response.data.data.all;
                    this.products_in_cat = response.data.data.in_cat;
                    if (this.keyword != '') this.products = this.brandproduct.products;
                    // console.log(this.products_in_cat);
                    // console.log(this.products_all);
                })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        // console.log(this.products_in_cat);
                        this.loading = false;
                        this.show_payload = true;
                    });
            }
        },
        computed: {
            // use this to later do bolds on all matching keywords.
            highlighted_products() {
                return this.products.map(function (product) {
                    return product;
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
        columns: 4;
        text-indent: 0 !important;
        margin: 0;
    }

    li {
        margin: 0 5px .5em !important;
        text-indent: 0;
        padding: 0;
        line-height: 1.2em;
        display: block;
    }

    a {
        color: #42b983;
    }

    .show_all_products_button {
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
    }

    .span.active {
        color: red;
    }
</style>
